// AUDITORIA-CLINICA-ELEGIBILIDAD (front) -- lectura de la clasificación
// histórica que YA calcula el backend (ELEGIBILIDAD-53,
// FAuditClinicalElegibilidad.ts) y expone tanto el listado como el detalle en
// `eligibilidad_historica` + `puede_corregir_auditoria`.
//
// Aquí NO se reimplementa ninguna regla: el front sólo decide cómo se muestra.
// Es deliberadamente DEFENSIVO -- si una respuesta no trae los campos (un
// backend más viejo), no se bloquea nada y la pantalla se comporta como antes.
//
// Motivo del caso real que lo dispara: citas "Sin confirmar" que el cron
// llevó a Finalizada sin que el paciente llegara nunca. Sólo tienen el motivo
// de consulta y ningún registro clínico: corregirlas sería fabricar historia.

export const ELEGIBILIDAD = {
    ATENDIDA: "ATENDIDA_DEMOSTRABLE",
    NO_ATENDIDA: "NO_ATENDIDA_DEMOSTRABLE",
    INDETERMINADA: "INDETERMINADA",
};

// Texto de cara al auditor. El backend responde 409 con su propio mensaje si
// alguien intenta corregir igual; este explica el porqué ANTES de intentarlo.
export const MOTIVO_NO_AUDITABLE =
    "Esta atención no tiene evidencia de consulta: no consta que el paciente haya pasado a «En consulta» y no hay ningún registro clínico. No se puede corregir desde Auditoría Clínica.";

/**
 * ¿Se pueden registrar correcciones sobre esta atención?
 * Se prefiere el booleano que manda el backend; si no viene, se deriva de la
 * clasificación; si tampoco viene, no se bloquea (fail-open a propósito: un
 * campo ausente no es una prohibición).
 */
export function puedeCorregirse(dto) {
    if (!dto) return true;
    if (typeof dto.puede_corregir_auditoria === "boolean") return dto.puede_corregir_auditoria;
    if (dto.eligibilidad_historica) return dto.eligibilidad_historica !== ELEGIBILIDAD.NO_ATENDIDA;
    return true;
}

/**
 * Chip de elegibilidad, o `null` cuando no hay nada que decir.
 * INDETERMINADA no pinta chip: es el ~98,6% del histórico y marcarlo en todas
 * las filas sería ruido, no información. Sólo se señala lo que de verdad es
 * una señal: atención probada, o imposibilidad probada.
 */
export function chipElegibilidad(dto) {
    const valor = dto?.eligibilidad_historica;
    if (valor === ELEGIBILIDAD.NO_ATENDIDA) {
        return { color: "error", label: "No auditable", detalle: MOTIVO_NO_AUDITABLE };
    }
    if (valor === ELEGIBILIDAD.ATENDIDA) {
        return {
            color: "success",
            label: "Atención probada",
            detalle: "Consta que la cita pasó por «En consulta»: hay evidencia de atención real.",
        };
    }
    return null;
}
